var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.$router.options.routes),function(entry){return (entry.menu==_vm.menu)?_c('li',[_c('kms-a',{class:{ 'router-link-exact-active': entry.name == _vm.$route.name },attrs:{"to":entry.path}},[_vm._v(_vm._s(entry.name))])],1):_vm._e()}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11dcb67a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/Navigation.vue
// module id = null
// module chunks = 